import { KMLEntry } from '../../interfaces';

export const metadataFields = [
  'enforce_start',
  'enforce_end',
  'enforce2_start',
  'enforce2_end',
  'enforce_days',
  'position',
  'route_direction',
  'block_name',
  'route_id',
  'lane_scale',
  'active_lane_selection',
  'lane_distance',
];

/**
 * convert degrees to radians
 * @param deg degrees
 * @returns {number} radians
 */
const deg2rad = (deg: number): number => deg * (Math.PI / 180);

/**
 * formula to find real distance between two coordinates
 * @returns {number} distance in meters
 */
export const haversineFormula = (lat1: number, lon1: number, lat2: number, lon2: number) => {
  const R = 6371 * 1000; // Radius of the earth in m
  const dLat = deg2rad(lat2 - lat1); // deg2rad below
  const dLon = deg2rad(lon2 - lon1);
  const a = Math.sin(dLat / 2) ** 2 + Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * Math.sin(dLon / 2) ** 2;
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c; // Distance in m
};

export const mergeMetadataFromPoints = (source: KMLEntry[], destination: KMLEntry[]) => {
  const copyThresholdMeters = 2;
  destination.forEach((destinationItem: KMLEntry) => {
    const sourceLength = source.length;
    for (let i = 0; i < sourceLength; ++i) {
      const distanceBetweenPoints = haversineFormula(destinationItem.lat, destinationItem.lon, source[i].lat, source[i].lon);
      if (distanceBetweenPoints < copyThresholdMeters) {
        destinationItem = copyMetadataFromPoint(source[i], destinationItem);
      }
    }
  });
  return destination;
};

const copyMetadataFromPoint = (source: any, destination: any) => {
  metadataFields.forEach((field) => {
    destination[field] = source[field];
  });
  return destination;
};
